import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-6">
      <div className="text-center">
        <h1 className="text-8xl font-extrabold text-blue-600">404</h1>

        <h2 className="mt-4 text-3xl font-bold text-gray-800">
          Page Not Found
        </h2>

        <p className="mt-3 text-gray-600 max-w-md mx-auto">
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>

        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center rounded-lg bg-blue-600 px-6 py-3 text-white font-medium hover:bg-blue-700 transition"
          >
            Go Back Home
          </Link>
        </div>
      </div>

      <div className="mt-12">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-48 h-48 text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.172 9.172a4 4 0 015.656 0M8 15h8m-4-9v.01M3 12a9 9 0 1018 0 9 9 0 00-18 0z"
          />
        </svg>
      </div>
    </div>
  );
}